import React, { useEffect, useState } from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  LabelList,
  YAxis,
  ResponsiveContainer,
} from 'recharts';
import { Oval } from 'react-loader-spinner';

export default function EthnicityBarChart({
  title,
  subtitle,
  icon,
  data,
  loading,
  selectorOne,
  selectorTwo,
}) {
  const [chartRendered, setChartRendered] = useState(false);

  useEffect(() => {
    if (!loading) {
      // Delay the re-render by 1 second
      const timeout = setTimeout(() => {
        setChartRendered(true);
      }, 1250);

      return () => clearTimeout(timeout);
    }
  }, [loading]);

  const renderCustomizedLabel = (props) => {
    const { x, y, width, height, value } = props;

    return (
      <text
        x={x + width + 5}
        y={y + height - 5}
        fill='#636363'
        textAnchor='start'
        opacity={1}
      >
        {value}
      </text>
    );
  };

  return (
    <div className='flex h-96 w-full flex-row space-x-8 text-brandText'>
      <div className='flex h-full w-full flex-col overflow-hidden rounded-lg border-2 border-x-slate-100 border-t-slate-50 border-b-slate-100 bg-white pt-5 pb-3 shadow-md'>
        <div className='flex flex-row items-center'>
          <div>
            <div className='ml-3 flex'>
              <img
                className='h-12 w-12 sm:h-14 sm:w-14'
                src={icon}
                alt='Grades'
              />
            </div>
          </div>
          <div>
            <h2 className='ml-2 text-2xl font-medium sm:text-3xl'>{title}</h2>
            <p className='ml-2 text-sm'>{subtitle}</p>
          </div>
        </div>
        {!loading && data?.length > 0 ? (
          <div className='mt-3 flex h-full w-full px-1 font-bold text-brandText'>
            {chartRendered && (
              <ResponsiveContainer>
                <BarChart
                  data={data}
                  layout='vertical'
                  barCategoryGap='23%'
                  margin={{ top: 0, right: 200, left: 0, bottom: 0 }}
                >
                  <defs>
                    <linearGradient id='colorUv' x1='0' y1='0' x2='1' y2='0'>
                      <stop offset='0' stopColor='#11CCEA' stopOpacity={1} />
                      <stop offset='1' stopColor='#e9fbfd' stopOpacity={1} />
                    </linearGradient>
                  </defs>
                  <XAxis type='number' hide />
                  <YAxis
                    type='category'
                    width={30}
                    padding={{ left: 0 }}
                    dataKey={selectorOne}
                    tickLine={false}
                    axisLine={false}
                    tick={false}
                  />

                  <Bar
                    dataKey={selectorTwo}
                    radius={[5, 5, 5, 5]}
                    fill='url(#colorUv)'
                  >
                    <LabelList
                      dataKey={selectorOne}
                      content={renderCustomizedLabel}
                      position='insideRight'
                    />
                  </Bar>
                </BarChart>
              </ResponsiveContainer>
            )}
          </div>
        ) : (
          <div className='flex h-full w-full flex-col items-center justify-center pb-5 text-4xl font-normal text-gray-200'>
            {loading || !chartRendered ? (
              <div>
                <Oval
                  height={80}
                  width={80}
                  color='#0CB2DA'
                  wrapperStyle={{}}
                  wrapperClass=''
                  visible={true}
                  ariaLabel='oval-loading'
                  secondaryColor='#e5e7eb'
                  strokeWidth={2}
                  strokeWidthSecondary={2}
                />
              </div>
            ) : (
              <div>No Records</div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
